import countryList from 'react-select-country-list';
import { Country, State, City } from "country-state-city";

export const countryCodeData = countryList().getData()
export const countryCodeMap = countryList().getData().reduce((acc, country) => {
    acc[country.label] = country.value;
    return acc;
}, {});

export const getCountryName = (portCode) =>{
    //console.log("getCountryName is executing-------",portCode)
    const countryCode = portCode?.substring(0,2)
    const country = countryCodeData.find(country => country.value === countryCode);
    // console.log("---country---",country)
    return (country.label ? country.label : null);
}

export const getCountryCode = (countryName) => {
  if (!countryName) return null;
  //console.log("countryCodeMap: ",countryCodeMap)
  const normalized = countryName.trim().toLowerCase();

  const countryAliasMap = {
    "vietnam": "Viet Nam",
    "korea": "Korea, Republic of",
    "taiwan": "Taiwan, Province of China",
    "usa": "United States",
  };

  const properName = countryAliasMap[normalized] || 
    Object.keys(countryCodeMap).find(
      name => name.trim().toLowerCase() === normalized
    );

  return countryCodeMap[properName] || null;

};

// Function to remove accents/diacritics from a string
const removeAccents = (str) => {
  // Null-safe: callers may pass an undefined city/state name (e.g. a door with no
  // city). Treat it as empty so normalizeCityName / findStateCodeByCityAndCountryName
  // return "no match" instead of throwing on undefined.normalize().
  return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
};

// Function to normalize city names (convert to lowercase and remove accents)
const normalizeCityName = (cityName) => {
  return removeAccents(cityName).toLowerCase();
};

export const findStateCodeByCityAndCountryName = (cityName, countryName) => {
  // console.log("findStateCodeByCityAndCountryName is executing-------", cityName, countryName)
  let cityFound = null;
  let stateFallback = null;
  
  // Special case for Antwerp -> Antwerpen
  if (cityName && cityName.toLowerCase() === 'antwerp' && countryName === 'Belgium') {
    cityName = 'Antwerpen';
  }
  if (countryName === "USA") {
    countryName = "United States";
  }
  
  // if (countryName === "Canada") {
    // First, find the country code based on the country name
    const country = Country.getAllCountries().find(
      (c) => c.name === countryName
    );
    if (!country) return null; // Country not found
    // console.log("country: ", country, country.isoCode);
    // Then, find all states within this country
    const states = State.getStatesOfCountry(country.isoCode);
    // console.log("states: ", states);
    // Now, find the city by name within the found states

    for (let state of states) {
      const cities = City.getCitiesOfState(country.isoCode, state.isoCode);
      const city = cities.find(
        (c) =>
          normalizeCityName(c.name) === normalizeCityName(cityName)
      );
      // console.log("cities: ", cities, "city: ", city);
      if (city) {
        cityFound = city;
        break;
      }
    }
    if (!cityFound && Array.isArray(states)) {
      const stateMatch = states.find(
        (state) =>
          normalizeCityName(state.name) === normalizeCityName(cityName)
      );
      // console.log("stateMatch: ", stateMatch);
      if (stateMatch) {
        stateFallback = stateMatch.isoCode;
      }
    }
  // }
  // Return the state code of the found city, or null if not found
  return cityFound ? cityFound.stateCode : stateFallback;
};
